import { Api } from '@bimdata/client';

export const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT.replace(/[\\/]+$/i, '');

const api: Api = Api.instance(API_ENDPOINT, '0.0.1');

export const pub: Api = api.clone(true);

export default api;
